import React, { useEffect, useState } from 'react';

const RealEstateSchemaMarkup: React.FC<{ url: string, imoveis: any, tipo: string }> = ({ url, imoveis, tipo }) => {
    const [rendered, setRendered] = useState(false);

    useEffect(() => {
        if (!rendered) {
            // Verifica se estamos no lado do cliente
            if (typeof window !== 'undefined') {
                const getSchema = (imovel: any) => {
                    const images = imovel?.fotos?.url_foto ? imovel?.fotos?.url_foto : imovel?.fotos?.length > 0 ? imovel?.fotos.map((foto: { url_foto: any; }) => foto.url_foto) : "";
                    const type = tipo === 'imovel' ? 'RealEstateListing' : imovel?.venda ? 'BuyAction' : 'RentAction'

                    const schema = imovel?.link_video ? {
                        "@context": "http://schema.org",
                        "@type": type,
                        "name": `${imovel?.titulo}`,
                        "price": `${imovel?.aluguel ? imovel?.preco_locacao : imovel?.preco_venda}`,
                        "description": `${imovel?.descricao}`,
                        "image": images,
                        "priceSpecification": {
                            "@type": "PriceSpecification",
                            "priceCurrency": "BRL"
                        },
                        "object":{
                            "@type":"Place",
                            "address":{
                                "@type":"PostalAddress",
                                "streetAddress":"",
                                "addressLocality":""
                            },
                            "name":`${imovel?.titulo}`,
                            "image": images,
                            "url":`${url}`,
                        },
                        "video": {
                            "@type": "VideoObject",
                            "name": "Vídeo do Imóvel",
                            "description": `Um tour em vídeo do imóvel código ${imovel?.referencia}.`,
                            "thumbnailUrl": imovel?.fotos[0]?.url_foto || '',
                            "uploadDate": "2024-02-21T08:00:00+08:00",
                            "duration": "PT2M5S",
                            "contentUrl": imovel?.link_video,
                            "embedUrl": imovel?.link_video
                        }
                    } : {
                        "@context": "http://schema.org",
                        "@type": type,
                        "name": `${imovel?.titulo}`,
                        "price": `${imovel?.aluguel ? imovel?.preco_locacao : imovel?.preco_venda}`,
                        "description": `${imovel?.descricao}`,
                        "image": images,
                        "priceSpecification": {
                            "@type": "PriceSpecification",
                            "priceCurrency": "BRL"
                        },
                        "object":{
                            "@type":"Place",
                            "address":{
                                "@type":"PostalAddress",
                                "streetAddress": `${imovel?.endereco}`,
                                "addressLocality": `${imovel?.cidade?.nome}`
                            },
                            "name":`${imovel?.titulo}`,
                            "image": images,
                            "url":`${url}`,
                        }
                    };

                    return schema;
                };

                // Cria um novo script
                imoveis.forEach((imovel: any) => {
                    const script = document.createElement('script');
                    // Define o tipo do script
                    script.type = 'application/ld+json';
                    // Define o conteúdo do script como o schema serializado
                    script.innerHTML = JSON.stringify(getSchema(imovel));
                    // Adiciona o script ao final do body
                    document.body.appendChild(script);
                    // Define que o componente foi renderizado
                    setRendered(true);
                })
            }
        }
    }, [rendered,imoveis,tipo,url]); // Isso garante que o useEffect seja executado apenas uma vez

    // Função para gerar o schema
    return null;
}

export default RealEstateSchemaMarkup;
